/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserAvatar_user$ref: FragmentReference;
declare export opaque type UserAvatar_user$fragmentType: UserAvatar_user$ref;
export type UserAvatar_user = {|
  +name: string,
  +avatar: {|
    +url: string
  |},
  +$refType: UserAvatar_user$ref,
|};
export type UserAvatar_user$data = UserAvatar_user;
export type UserAvatar_user$key = {
  +$data?: UserAvatar_user$data,
  +$fragmentRefs: UserAvatar_user$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAvatar_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'faa7646b89482552ae84f61ad658d84f';

module.exports = node;
